module.exports = __webpack_public_path__ + "img/30.80c8cc1b.png";